import { render, staticRenderFns } from "./PublicChinaMap.vue?vue&type=template&id=c8f44660&scoped=true"
import script from "./PublicChinaMap.vue?vue&type=script&lang=js"
export * from "./PublicChinaMap.vue?vue&type=script&lang=js"
import style0 from "./PublicChinaMap.vue?vue&type=style&index=0&id=c8f44660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f44660",
  null
  
)

export default component.exports